import * as React from "react";
import { observer } from "mobx-react";
import { Footer } from "../organisms/Footer";
import { ContactViewStoreContext } from "../../context/store";
import { useContext, useState } from "react";
import { css } from "@emotion/core";
import * as firebase from "firebase/app";
import "firebase/auth";
import { Spin, message, Popconfirm } from "antd";
import { apiEndpoint } from "../../util";
import { RouteComponentProps } from "react-router-dom";

export const ApplicationDone = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);
  const [loading, setLoading] = useState(false);
  return (
    <div>
      <p>
        お申し込みありがとうございました。
        <br />
        送付先のゲストのご住所の入力フォームを1営業日以内にお送りさせて頂きます。
        <br />
        万が一届かない場合は大変お手数ですが、ご連絡ください。
      </p>
      {store.internal && (
        <Popconfirm
          title={
            <div>
              お申込みの取り消しを行います。
              <br />
              お申込み内容の調整は、お申込後も可能です。
              <br />
              お早めにお申し込み頂いた方が、より多くのサービスを受けられる場合がございます。
              <br />
              本当にキャンセルしますか？
            </div>
          }
          disabled={loading}
          onConfirm={() => {
            const currentUser = firebase.auth().currentUser;
            if (currentUser === null) return;

            setLoading(true);
            store.isOrdered = false;
            store
              .linkCredential()
              .then(_ => store.persist())
              .then(_ =>
                fetch(apiEndpoint("/postal/orders"), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(store.toRequest("cancel"))
                })
              )
              .then(response => {
                if (response.status >= 400) throw new Error("server error");
                message.success("キャンセルしました");
                setLoading(false);
                history.push("/application/order");
              })
              .catch(e => {
                console.log("error", e);
                alert("エラーが発生しました");
                setLoading(false);
              });
          }}
          onCancel={() => {}}
          okText="はい"
          cancelText="いいえ"
        >
          <a
            css={css`
              color: #90c2ec;
              text-decoration: underline;
            `}
          >
            誤って「お申込みボタン」を押してしまった方
          </a>
          {loading && <Spin size="small" />}
        </Popconfirm>
      )}
      <Footer />
    </div>
  );
});
